import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchSortFilterJob } from "../../features/jobsFinder/jobsFinderSlice";

export default function JobsFinderHeader() {
  const { jobType } = useSelector((state) => state.jobs);
  const dispatch = useDispatch();
  const [searchValue, setSearchJobValue] = useState("");
  const [sort, setSort] = useState("");

  useEffect(() => {
    setSearchJobValue("");
    setSort("");
  }, [jobType]);

  const handleChangeSearch = (e) => {
    setSearchJobValue(e.target.value);
  };
  const handleChangeSort = (e) => {
    const selected = e.target.value;
    setSort(selected);
    dispatch(searchSortFilterJob({ searchValue, sort: selected }));
  };

  const handleEnterPress = (e) => {
    if (e.keyCode === 13) {
      dispatch(searchSortFilterJob({ searchValue, sort }));
    }
  };
  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="lws-section-title">
        {" "}
        {jobType ? `Available ${jobType}` : "All Available"} Jobs
      </h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            id="lws-searchJob"
            name="searchJob"
            value={searchValue}
            onChange={(e) => handleChangeSearch(e)}
            onKeyDown={handleEnterPress}
          />
        </div>
        <select
          id="lws-sort"
          autoComplete="sort"
          className="flex-1"
          name="sort"
          value={sort}
          onChange={(e) => handleChangeSort(e)}
        >
          <option value="">Default</option>
          <option value="LowToHigh">Salary (Low to High)</option>
          <option value="HighToLow">Salary (High to Low)</option>
        </select>
      </div>
    </div>
  );
}
